import * as React from 'react';
import * as styles from './styles.css';

export interface IPageProps {
  children: React.ReactNode;
}

export function Page({ children }: IPageProps): React.JSX.Element {
  return <div className={styles['container']}>{children}</div>;
}
